import React from 'react';

import type { ImageProps } from 'expo-image';

import { FullWidthAutoHeightImage } from 'components/picture';

interface HeaderFlairProps {
  source: ImageProps['source'];
}

export const HeaderFlair = ({ source }: HeaderFlairProps) => (
  <FullWidthAutoHeightImage style={{ position: 'absolute', top: 0 }} source={source} />
);
